const content = {
    page1: {
        pageheading: "content.page1.pageheading",
        pagesubheading1: "content.page1.pagesubheading1",
        pagesubheading2: "content.page1.pagesubheading2",
        image: "assets/realestate-main-image.webp",
        contentpage: [
            {
                contentheading: "content.page1.contentpage1.contentheading",
                contentleft: "content.page1.contentpage1.contentleft",
                contentright: "content.page1.contentpage1.contentright",
                webaddress: "content.page1.contentpage1.webaddress",
                image: "assets/sector-content-box-image-real-estate-2.webp",
            },
            {
                contentheading: "content.page1.contentpage2.contentheading",
                contentleft: "content.page1.contentpage2.contentleft",
                contentright: "content.page1.contentpage2.contentright",
                image: "assets/sector-content-box-image-real-estate-3.webp",
            },
        ],
    },
    page2: {
        pageheading: "content.page2.pageheading",
        pagesubheading1: "content.page2.pagesubheading1",
        pagesubheading2: "content.page2.pagesubheading2",
        image: "assets/financial-main-image.webp",
        contentpage: [
            {
                contentheading: "content.page2.contentpage1.contentheading",
                contentleft: "content.page2.contentpage1.contentleft",
                contentright: "content.page2.contentpage1.contentright",
                webaddress: "content.page2.contentpage1.webaddress",
                image: "assets/sector-content-box-image-finance.webp",
            },
            {
                contentheading: "content.page2.contentpage2.contentheading",
                contentleft: "content.page2.contentpage2.contentleft",
                contentright: "content.page2.contentpage2.contentright",
                webaddress: "content.page2.contentpage2.webaddress",
                image: "assets/financial-content-img-2.webp",
            },
        ],
    },
    page3: {
        pageheading: "content.page3.pageheading",
        pagesubheading1: "content.page3.pagesubheading1",
        pagesubheading2: "content.page3.pagesubheading2",
        image: "assets/transport-main-image.webp",
        contentpage: [
            {
                contentheading: "content.page3.contentpage1.contentheading",
                contentleft: "content.page3.contentpage1.contentleft",
                contentright: "content.page3.contentpage1.contentright",
                image: "assets/investment-image3.webp",
                extracontentleft: "content.page3.contentpage1.extracontentleft",
                extracontentright: "content.page3.contentpage1.extracontentright",
            },
        ],
    },
    page4: {
        pageheading: "content.page4.pageheading",
        pagesubheading1: "content.page4.pagesubheading1",
        pagesubheading2: "content.page4.pagesubheading2",
        image: "assets/manufacturing-main-image.webp",
        contentpage: [
            {
                contentheading: "content.page4.contentpage1.contentheading",
                contentleft: "content.page4.contentpage1.contentleft",
                contentright: "content.page4.contentpage1.contentright",
                webaddress: "content.page4.contentpage1.webaddress",
                image: "assets/sector-content-box-image-manufacturing-2.webp",
            },
            {
                contentheading: "content.page4.contentpage2.contentheading",
                contentleft: "content.page4.contentpage2.contentleft",
                contentright: "content.page4.contentpage2.contentright",
                image: "assets/sector-content-box-image-manufacturing-3.webp",
            },
        ],
    },
    page5: {
        pageheading: "content.page5.pageheading",
        pagesubheading1: "content.page5.pagesubheading1",
        pagesubheading2: "content.page5.pagesubheading2",
        image: "assets/education-main-image.webp",
        contentpage: [
            {
                contentheading: "content.page5.contentpage1.contentheading",
                contentleft: "content.page5.contentpage1.contentleft",
                contentright: "content.page5.contentpage1.contentright",
            },
            {
                contentheading: "content.page5.contentpage2.contentheading",
                contentleft: "content.page5.contentpage2.contentleft",
                contentright: "content.page5.contentpage2.contentright",
                image: "assets/investment-image5.webp",
            },
        ],
    },
    page6: {
        pageheading: "content.page6.pageheading",
        pagesubheading1: "content.page6.pagesubheading1",
        pagesubheading2: "content.page6.pagesubheading2",
        image: "assets/energy-material-main-image.webp",
        contentpage: [
            {
                contentleft: "content.page6.contentpage1.contentleft",
                contentright: "content.page6.contentpage1.contentright",
                extracontentleft: "content.page6.contentpage1.extracontentleft",
                image: "assets/sector-content-box-image-energy.webp",
            },
        ],
    },
    page7: {
        pageheading: "content.page7.pageheading",
        pagesubheading1: "content.page7.pagesubheading1",
        pagesubheading2: "content.page7.pagesubheading2",
        image: "assets/food-main-image.webp",
        contentpage: [
            {
                contentheading: "content.page7.contentpage1.contentheading",
                contentleft: "content.page7.contentpage1.contentleft",
                contentright: "content.page7.contentpage1.contentright",
                image: "assets/sector-content-box-image-food.webp",
            },
            {
                contentheading: "content.page7.contentpage2.contentheading",
                contentleft: "content.page7.contentpage2.contentleft",
                contentright: "content.page7.contentpage2.contentright",
                image: "assets/food-main-image.webp",
            },
        ],
    },
};

export default content;
